var identity = identity || {};
identity.campaign = {
  init: function() {
    identity.campaign.elements.splash.init();
    identity.campaign.elements.takeover.init();
    identity.campaign.elements.paragraph.init();
  },
  hasCookieConsent: (function() {
    return window.CookieInformation !== undefined ? window.CookieInformation._getVisitorId() !== false || location.host.indexOf( 'staging' ) > -1 : true;
  })(),
  elements: {
    takeover: {
      _root: null,
      _timeout: null,
      _duration: 0,
      _closeOnClick: false,
      _loop: false,
      init: () =>{
        identity.campaign.elements.takeover._root = document.querySelector('.js-custom-fullscreen-takeover');
        if ( identity.campaign.elements.takeover._root !== null ) {
          identity.campaign.elements.takeover._closeOnClick = identity.campaign.elements.takeover._root.dataset.closeOnClick === 'True';
          identity.campaign.elements.takeover._duration = parseInt(identity.campaign.elements.takeover._root.dataset.duration);
          identity.campaign.elements.takeover._loop = identity.campaign.elements.takeover._root.dataset.loop === 'true';
          document.body.classList.add('modal-open');
          identity.campaign.elements.takeover.bindEvents();
        }
      },
      bindEvents: () =>{
        const takeOverAnimationElement = identity.campaign.elements.takeover._root.querySelector('.js-takeover-animation');
        takeOverAnimationElement.addEventListener('animationend', identity.campaign.elements.takeover.onAnimateIn);
        
        if(identity.campaign.elements.takeover._closeOnClick){
          identity.campaign.elements.takeover._root.addEventListener('click', (event) =>{
            event.preventDefault();
            if(identity.campaign.elements.takeover._timeout !== null){
              clearTimeout(identity.campaign.elements.takeover._timeout);
            }
            identity.campaign.elements.takeover.onAnimateOut();
          })
        }
      },
      onAnimateIn: (event) =>{
        const takeOverAnimationElement = event.target;
        const background = identity.campaign.elements.takeover._root.querySelector('.js-takeover-background');
        takeOverAnimationElement.removeEventListener('animationend', identity.campaign.elements.takeover.onAnimateIn);
        takeOverAnimationElement.addEventListener('animationend', identity.campaign.elements.takeover.onAnimateOut);
        
        // When loop is enabled, the takeover must stay open indefinitely, so auto-close is disabled.
        if ( identity.campaign.elements.takeover._loop === false ) {
          identity.campaign.elements.takeover._timeout = setTimeout(() =>{
            takeOverAnimationElement.classList.add('animate-out');
            background.classList.add('animate-out');
          }, identity.campaign.elements.takeover._duration)
        }
      },
      onAnimateOut: (event) =>{
        document.body.classList.remove('modal-open');
        identity.campaign.elements.takeover._root.remove();
      },
    },
    splash: {
      
      init: function() {
        var jSplash = jQuery( '.js-identity-splash-modal' );
        if ( jSplash.length === 1 ) {
          identity.campaign.elements.splash.handleCookieConsent( jSplash );
          identity.campaign.elements.splash.bindEvents( jSplash );
        }
      },
      handleCookieConsent: function( jSplash ) {
        if ( identity.campaign.hasCookieConsent === false ) {
          window.addEventListener( 'CookieInformationConsentGiven', function() {
            var jVideo = jSplash.find( '.js-identity-splash-video' );
            identity.campaign.elements.splash.video.play( jVideo.get( 0 ) );
          } );
        }
      },
      bindEvents: function( jSplash ) {
        jSplash.on( 'show.bs.modal', function( event ) {
          var jVideo = jQuery( event.currentTarget ).find( '.js-identity-splash-video' );
          if ( jVideo.length === 1 ) {
            if ( identity.campaign.hasCookieConsent === true ) {
              identity.campaign.elements.splash.video.play( jVideo.get( 0 ) );
            } else {
              identity.campaign.elements.splash.video.stop( jVideo.get( 0 ) );
            }

          }
        } ).on( 'hide.bs.modal', function( event ) {
          var jVideo = jQuery( event.currentTarget ).find( '.js-identity-splash-video' );
          if ( jVideo.length === 1 ) {
            identity.campaign.elements.splash.video.stop( jVideo.get( 0 ) );
            identity.campaign.elements.splash.setCookie();
          }
        } ).modal( 'show' );

        jSplash.on( 'click', '.js-e-block-link', function( event ) {
          event.preventDefault();
          identity.campaign.elements.splash.setCookie();
          location.href = event.target.href;
        } );
      },
      setCookie: function() {
        var date = new Date();
        date.setTime( date.getTime() + (30 * 24 * 60 * 60 * 1000) );
        var expires = 'expires=' + date.toUTCString();
        document.cookie = 'Identity.Splash=True;' + expires + ';path=/';
      },
      video: {
        play: function( domVideo ) {
          domVideo.play();
          // When loop is enabled the video never fires "ended", so auto-close on video end is effectively disabled.
          if ( domVideo.dataset.loop !== 'true' ) {
            identity.campaign.elements.splash.video.onEnd();
          }
        },
        stop: function( domVideo ) {
          domVideo.pause();
        },
        onEnd: function() {
          var domVideo = document.querySelector( '.js-identity-splash-video' );
          domVideo.addEventListener( 'ended', function() {
            jQuery( '.js-identity-splash-modal' ).modal( 'hide' );
          }, false );
        },
      },
    },
    paragraph: {
      init: function() {
        jQuery( document ).on( 'loaded.e4.deferImages', function( event, domElm ) {
          var jImg = jQuery( domElm ),
              jParagraph = jImg.closest( '.p-imagetext' );
          if ( jParagraph.length === 1 ) {
            identity.campaign.elements.paragraph.addCustomStyle( jParagraph, jImg );
          }
        } );
        jQuery( window ).on( 'load resize', function() {
          identity.campaign.elements.paragraph.findAndStyle();
        } );
      },
      findAndStyle: function() {
        var jSectionWithOffsetBackground = jQuery( '.custom-offset-background' );
        if ( jSectionWithOffsetBackground.length > 0 ) {
          jSectionWithOffsetBackground.find( '.p-imagetext' ).each( function( index, domElm ) {
            var jImg = jQuery( domElm ).find( 'img' ),
                isDeferred = jImg.is( '.is-deferred' ),
                hasLoaded = jImg.is( '.has-loaded' );
            if ( jImg.length === 1 ) {
              if ( !isDeferred || (isDeferred && hasLoaded) ) {
                identity.campaign.elements.paragraph.addCustomStyle( jQuery( domElm ), jImg );
              }

            }

          } );
        }
      },
      addCustomStyle: function( jParagraph, jImg ) {
        var text = jParagraph.find( '.p-txt-container' );

        text.css( {
          maxWidth: jImg.width() + 'px',
          margin: '0 auto',
          padding: 0,
        } );
      },
    },
  },
};